import { CeNavigationHierarchy } from '~/features/tracking/model';

export const transformTrackingData = (data: CeNavigationHierarchy) => Object.fromEntries(Object.entries(data).map(([k, v]) => [k, v.toLowerCase()])) as CeNavigationHierarchy;
